import { Routes } from '@angular/router';
import authRoutes from '@pages/auth/routes';
import dashboardRoutes from '@pages/dashboard/routes';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'links/profile',
    redirectTo: 'dashboard/my-account',
    pathMatch: 'full',
  },
  {
    path: 'links/marketing-message',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  ...dashboardRoutes,
  ...authRoutes,
  {
    path: 'success-delete',
    loadComponent: () =>
      import('./pages/dashboard/more/sucess-delete-account/sucess-delete-account.component').then(
        mod => mod.SuccessDeleteAccountComponent
      ),
  },
  {
    path: 'success-download-user-data',
    loadComponent: () =>
      import('./pages/dashboard/more/success-download-user-data/success-download-user-data.component').then(
        mod => mod.SuccessDownloadUserDataComponent
      ),
  },
  {
    path: 'delete-account-guide',
    loadComponent: () =>
      import('./pages/unauth-pages/detete-account-guide/detete-account-guide.component').then(
        mod => mod.DeleteAccountGuideComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        mod => mod.NotFoundComponent
      ),
  },
];

export default routes;
